import { APIResponse } from '../../../system-libraries/api-types';
import { getUserDetails } from './get-user-details';
import { getMTrackServiceStatus } from './get-mtrack-status';
import { getClientsConsent } from './get-clients-consent';
import { MTrackConsentData } from './types';

export const getMTrackConsentData = async (): Promise<APIResponse<MTrackConsentData>> => {
  const aggregatedConsent = {
    status: null,
    data: null,
    error: false,
  };

  try {
    const { data: userDetails } = await getUserDetails();
    const { customer_id: company_id } = userDetails?.customers[0];
    const { id: customer_id } = userDetails;

    const { data: whiteListConsent } = await getMTrackServiceStatus(company_id);
    const { data: clientConsent } = await getClientsConsent(customer_id);

    return {
      ...aggregatedConsent,
      data: {
        userDetails,
        whiteListConsent: whiteListConsent?.data?.consent,
        clientConsent: clientConsent?.data?.consent,
      },
      status: 200,
    };
  } catch (error) {
    return {
      ...aggregatedConsent,
      error,
    };
  }
};
